import { Sheet, SheetContent, SheetTitle } from '@/components/ui/Sheet';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { uiActions } from '@/store/slices/uiSlice';
import { env } from '@/lib/env';
import { SidebarNav } from './SidebarNav';

export function MobileSidebar() {
  const dispatch = useAppDispatch();
  const open = useAppSelector((state) => state.ui.mobileSidebarOpen);

  const close = () => dispatch(uiActions.setMobileSidebarOpen(false));

  return (
    <Sheet open={open} onOpenChange={(next) => dispatch(uiActions.setMobileSidebarOpen(next))}>
      <SheetContent side="left" className="flex w-[min(100vw-3rem,18rem)] flex-col p-0">
        <SheetTitle className="border-b px-4 py-4 text-left text-lg font-semibold">
          {env.VITE_APP_NAME}
        </SheetTitle>
        <SidebarNav onNavigate={close} />
      </SheetContent>
    </Sheet>
  );
}
